import * as RoutePathConstants from '../../../../constants/RoutePathConstants'
import * as ReturnCodesConstants from '../../../../constants/ReturnCodesConstants'
import { mapActions, mapGetters, mapState } from 'vuex'
import { checkReturnInfo } from '../../../../common/utils/return-message-util'
import * as DictionaryConstants from '../../../../constants/DictionaryConstants'
import goOutManagement from './components/go-out-management'
export default {
  data () {
    return {
      labelPosition: 'left',
      showState: '',
      cancelType: '',
      verifySalesAmount: '',
      btnTypeCouponCancel: 'primary',
      btnTypeCouponAndAmountCancel: '',
      centerHeight: document.documentElement.clientHeight - 235 + 'px',
      form: {

      },
      addForm: {
        memberName: '',
        identityNumber: '',
        phoneNumber: '',
        mobilePhoneVerificationCode: '',
        gender: '',
        homeAddress: ''
      },
      content: '获取验证码',
      canClick: false,
    }
  },
  components: {
    goOutManagement: goOutManagement
  },
  computed: {
    ...mapState('wxMemberModule', ['qrCode', 'memberDetail', 'cancelTypeOptions', 'maritalStatus',
      'occupation', 'hobby', 'vehicleUse']),
    ...mapGetters('wxMemberModule', ['memberAvatarUrl', 'memberVerificationStatus']),
    avatarUrl () {
      return this.memberAvatarUrl
    },
    memberDetails () {
      return this.memberDetail
    },
    maritalStatusInfo () {
      return this.maritalStatus
    },
    occupationList () {
      return this.occupation
    },
    hobbyList () {
      return this.hobby
    },
    vehicleUseList () {
      return this.vehicleUse
    },
    certificated () {
      return true
      // return this.memberVerificationStatus
    }
  },
  methods: {
    ...mapActions('wxMemberModule', ['getWXSignature', 'getMemberDetail', 'cancelCoupon', 'getUserInfo', 'getCancelRecord',
      'getCancelTypeOptions', 'getDictInfosByTypeCode', 'getCaptcha', 'getCaptchaAuthNew', 'memberAuthentication',
      'updateMemberDetailsById', 'uploadFileGetMemberInfo']),
    async getCode () {
      const myreg = /^(((13[0-9]{1})|(15[0-9]{1})|(16[0-9]{1})|(14[0-9]{1})|(18[0-9]{1})|(17[0-9]{1})|(19[0-9]{1}))+\d{8})$/
      if (!this.addForm.phoneNumber) {
        this.$message.error('手机号不能为空！')
        return
      }
      if (!myreg.test(this.addForm.phoneNumber)) {
        this.$message.error('手机号格式不正确！')
        return
      }
      let data = {
        phoneNumber: this.addForm.phoneNumber
      }
      const result = await this.getCaptchaAuthNew(data)
      if (result && result.code === ReturnCodesConstants.REPEAT_VERIFICATION_CODE) {
        this.$message.warning(result.info)
        return
      }
      if (result && result.code == 'MEMBER-0006') {
        this.$message.warning('该手机号不存在')
        return
      }
      this.canClick = true
      this.checkCodeState = true
      this.setTime(60)
      // this.getIdentifyingCode()
    },
    setTime (totalTime) {
      if (!this.canClick) return // 如果是false 直接return出去
      this.content = totalTime + 's后重新发送'
      this.clock = window.setInterval(() => {
        totalTime--
        this.content = totalTime + 's后重新发送'
        if (totalTime < 0) {
          window.clearInterval(this.clock)
          this.content = '重新发送验证码'
          this.canClick = false // 这里重新开启
        }
      }, 1000)
    },
    scanCode () {
      // 获取微信签名
      this.getWXSignature(location.href.split('#')[0])
    },
    async cancellationAfterVerification () {
      if (!this.cancelType) {
        this.$message.warning('核销类型不能为空')
        return false
      }
      if (!this.qrCode) {
        this.$message.warning('核销码不能为空')
        return false
      }
      if (this.cancelType === DictionaryConstants.COUPON_AND_SALES_AMOUNT_CANCELLATION &&
        !this.verifySalesAmount) {
        this.$message.warning('现金不能为空')
        return false
      }
      const data = {
        verifySalesType: this.cancelType,
        couponExampleCode: this.qrCode,
        verifySalesAmount: this.verifySalesAmount
      }
      const result = await this.cancelCoupon(data)
      checkReturnInfo(result, '卡券核销')
    },
    async getUserContext () {
      const result = await this.getUserInfo()
      // console.log('result', result)
      // 判断当前登录人是会员还是员工
      if (result.data.itemType === 1000) {
        this.getMemberDetail()
        this.showState = 1000
      } else if (result.data.itemType === 1) {
        this.showState = 1
      }
    },
    async updateMemberDetails () {
      let params = {
        phoneNumber: this.memberDetails.phoneNumber,
        gender: this.memberDetails.gender ? this.memberDetails.gender * 1 : null,
        homeAddress: this.memberDetails.homeAddress,
        maritalStatus: this.memberDetails.maritalStatus ? this.memberDetails.maritalStatus * 1 : null,
        occupation: this.memberDetails.occupation ? this.memberDetails.occupation * 1 : null,
        hobby: this.memberDetails.hobby ? this.memberDetails.hobby * 1 : null,
        vehicleUse: this.memberDetails.vehicleUse ? this.memberDetails.vehicleUse * 1 : null
      }
      let res = await this.updateMemberDetailsById(params)
      if (res.code === ReturnCodesConstants.SUCCESS_CODE) {
        this.$message.success(`修改成功！`)
        // this.getMemberDetail()
        setTimeout(this.$router.go(-1), 3000)
      } else {
        this.$message.error(`修改失败！`)
      }
    },
    async submitPersonalInformation () {
      if (!this.addForm.memberName) {
        this.$message.warning(`姓名不可为空！`)
        return
      }
      if (!this.addForm.identityNumber) {
        this.$message.warning(`身份证号不可为空！`)
        return
      }
      if (!this.addForm.phoneNumber) {
        this.$message.warning(`手机号不可为空！`)
        return
      }
      let params = {
        id: this.memberDetails.id,
        memberName: this.addForm.memberName,
        phoneNumber: this.addForm.phoneNumber,
        identityNumber: this.addForm.identityNumber,
        captcha: this.addForm.mobilePhoneVerificationCode,
        gender: this.addForm.gender ? this.addForm.gender * 1 : null,
        homeAddress: this.addForm.homeAddress
      }
      let res = await this.memberAuthentication(params)
      const isOk = res.code === ReturnCodesConstants.SUCCESS_CODE &&
        res.data && res.data.code === ReturnCodesConstants.SUCCESS_CODE
      if (isOk) {
        this.$message.success(`认证成功！`)
        // this.$router.push({
        //   path: RoutePathConstants.WX_PERSONAL_DETAIL,
        //   query: {
        //     type: 'authentication'
        //   }
        // })
        this.$router.push({
          path: RoutePathConstants.WX_PERSONAL_CENTER
        })
      } else {
        this.$message.error(`认证失败！`)
      }
    },
    // 上传之前对文件判断
    async beforeAvatarUpload (data) {
      // 这是限制上传文件类型
      const isLt2M = data.file.size / 1024 / 1024 < 10
      if (!isLt2M) {
        this.$message.error('上传文件大小不能超过 10MB!')
      } else {
        let resBase64 = await this.getBase64(data.file)
        let fileBase64 = resBase64.split(',')[1]
        // const result = await this.uploadFileGetVinCode(fileBase64)
        const response = await this.uploadFileGetMemberInfo(fileBase64)

        if (response && response.result) {
          const result = response.result
          this.addForm.identityNumber = result.number
          this.addForm.memberName = result.name
          this.addForm.gender = result.sex === '男' ? '1000' : '2000'
          this.addForm.homeAddress = result.address
        }
      }
    },
    // 上传成功或者失败都会触发
    returnStatus () {
      console.log()
    },
    // 限制文件上传个数
    handleExceed (file) {
      console.log(file)
    },
    async getBase64 (file) {
      return new Promise((resolve, reject) => {
        let reader = new FileReader()
        let fileResult = ''
        reader.readAsDataURL(file)
        reader.onload = function () {
          fileResult = reader.result
        }
        reader.onerror = function (error) {
          reject(error)
        }
        reader.onloadend = function () {
          resolve(fileResult)
        }
      })
    }
  },
  mounted () {
    // 获取会员信息
    this.getUserContext()
    // 查询字典获取核销方式
    this.getCancelTypeOptions(DictionaryConstants.CANCELLATION_AFTER_VERIFICATION_TYPE)
    this.getDictInfosByTypeCode()
  }
}



// WEBPACK FOOTER //
// ./src/pages/wx-member/member/views/personal-information.js